import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-tooltip-button',
    templateUrl: './tooltip-button.component.html',
    styleUrls: ['./tooltip-button.component.less'],
})
export class TooltipButtonComponent implements OnInit {
    @Input() isDisabled!: boolean;
    @Input() tooltip!: string;
    @Input() buttonText!: string;
    @Input() className = 'text-btn-primary';
    @Input() size = 'default';
    @Output() clickSuccess = new EventEmitter();
    constructor() {
    }

    ngOnInit(): void {
    }

    clickBtn(): void {
       this.clickSuccess.emit();
    }

}
